export default {
  created() {
    if (this.load) {
      this.load();
    }
  },

  watch: {
    "$route.query"() {
      if (this.load) {
        this.load();
      }
    }
  },

  methods: {
    applySortQuery(field, direction) {
      let query = Object.assign({}, this.$route.query);

      query.sort = (direction === "desc" ? "-" : "") + field;

      this.$router.replace({ query });
    },

    cloneQuery() {
      return Object.assign({}, this.$route.query);
    },

    clearQuery(key) {
      let query = this.cloneQuery();

      delete query[key];

      this.$router.replace({ query });
    },

    replaceQuery(key, value = null) {
      let query = this.cloneQuery();

      if (typeof key == "object") {
        for (let field in key) {
          query[field] = key[field];
        }
      } else {
        query[key] = value;
      }

      this.$router.replace({ query });
    }
  }
};
